/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceIdDto { 
    deviceClass?: DeviceIdDto.DeviceClassEnum;
    id?: number;
}
export namespace DeviceIdDto {
    export const DeviceClassEnum = {
        Collar: 'COLLAR',
        ExternalSensor: 'EXTERNAL_SENSOR',
        Camera: 'CAMERA',
        Tt4Sensor: 'TT4_SENSOR',
        ConfigurationDevice: 'CONFIGURATION_DEVICE',
        DropOff: 'DROP_OFF',
        TrapTransmitter: 'TRAP_TRANSMITTER',
        DataLogger: 'DATA_LOGGER'
    } as const;
    export type DeviceClassEnum = typeof DeviceClassEnum[keyof typeof DeviceClassEnum];
}


